import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  minWidth: 0,
  width: "100%",
};

export const details: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: 0.25,
};

export const name: SxProps<Theme> = {
  fontSize: "0.8125rem",
  fontWeight: 600,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const price: SxProps<Theme> = {
  fontSize: "0.71875rem",
  color: "text.secondary",
  lineHeight: 1.4,
};

export const quantity: SxProps<Theme> = {
  fontSize: "0.78125rem",
  color: "text.secondary",
  flexShrink: 0,
  whiteSpace: "nowrap",
};
